import styled from "styled-components";
import { BORDER_RADIUS, COLORS, SIZE } from "constants/variables";
import { ReactComponent as ActivityReportsIcon } from "assets/svg/ActivityReportsIcon.svg";
import { ReactComponent as OpenFolderIcon } from "assets/svg/OpenFolderIcon.svg";

export const ReportsSectionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ReportsSectionContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
  }
`;

export const ReportsSectionActivityCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: ${SIZE.max24};
  @media (max-width: 950px) {
    flex-direction: column;
    row-gap: ${SIZE.max24};
  }
`;

export const ReportsSectionIconWrapper = styled.div`
  width: fit-content;
`;

export const ReportsSectionIcon = styled(ActivityReportsIcon)`
  margin-inline: ${SIZE.max84} 0px;

  @media (max-width: 1500px) {
    padding-block: ${SIZE.max32} 0;
    margin-inline: ${SIZE.max40} 0;
  }

  @media (max-width: 1280px) {
    margin-inline: ${SIZE.max24} 0;
  }
`;

export const ReportsSectionActivityCardWrapper = styled.div`
  width: ${SIZE.max472};
  height: auto;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.RaisinBlack};
  padding: ${SIZE.max40};
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};
  /* max-height: 100%; */

  @media (max-width: 950px) {
    width: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const ReportsSectionActivityCardTitleWrapper = styled.div``;

export const ReportsSectionActivityCardTextWrapper = styled.div``;

export const ReportsSectionActivityCardButtonWrapper = styled.div`
  padding-top: ${SIZE.max18};
`;

export const ReportsSectionReportsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SIZE.max24};
  flex-wrap: wrap;
  max-width: ${SIZE.max780};

  @media (max-width: 1280px) {
    max-width: ${SIZE.max900};
  }

  @media (max-width: 950px) {
    justify-content: space-between;
    row-gap: ${SIZE.max40};
    max-width: 100%;
  }

  @media (max-width: 768px) {
    justify-content: space-between;
    row-gap: ${SIZE.max32};
  }
`;

export const ReportsSectionReportCardWrapper = styled.a`
  height: ${SIZE.max240};
  aspect-ratio: 1/1;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-block: ${SIZE.max40} ${SIZE.max55};
  border: 1px solid ${COLORS.AbsoluteWhite};
  transition: all 0.6s ease-in-out;
  text-decoration: none;
  :hover {
    background-color: ${COLORS.Background};
    cursor: pointer;
  }

  @media (max-width: 950px) {
    height: 19vw;
  }

  @media (max-width: 820px) {
    width: calc(50% - ${SIZE.max24});
    height: auto;
  }
`;

export const ReportsSectionReportCardTitleWrapper = styled.div``;

export const ReportsSectionReportCardIconWrapper = styled.div``;

export const ReportsSectionReportCardIcon = styled(OpenFolderIcon)`
  height: ${SIZE.max55};

  @media (max-width: 1280px) {
    height: ${SIZE.max80};
  }

  @media (max-width: 820px) {
    height: ${SIZE.max160};
  }

  @media (max-width: 768px) {
    width: ${SIZE.max160};
  }

  @media (max-width: 600px) {
    width: auto;
    height: auto;
  }

  ${ReportsSectionReportCardWrapper}:hover & {
    path {
      transition: fill 0.6s ease-in-out;
      fill: ${COLORS.Cultured};
    }
  }
`;
